import { OrderFields } from "../../../constants";
import useOrderFormik from "../../../hooks/useOrderFormik";

// This is to check if error needs to be shown inside new recipient
// that user has to first save address book entry before proceeding with the order

const useHasNewRecipientOrderErrors = (isNewRecipientFormVisible: boolean): boolean => {
  const { errors } = useOrderFormik();

  if (!isNewRecipientFormVisible) {
    return false;
  }

  const {
    [OrderFields.RECEIVER_NAME]: nameError,
    [OrderFields.RECEIVER_EMAIL]: emailError,
    [OrderFields.RECEIVER_PHONE_NUMBER]: phoneError,
    [OrderFields.RECEIVER_LOCKER]: lockerError,
    [OrderFields.RECEIVER_STREET]: streetError,
    [OrderFields.RECEIVER_HOUSE_NO]: houseNoError,
    [OrderFields.RECEIVER_FLAT_NO]: flatNoError,
    [OrderFields.RECEIVER_CITY]: cityError,
    [OrderFields.RECEIVER_ZIP_CODE]: zipCodeError,
  } = errors;

  return (
    !!nameError ||
    !!emailError ||
    !!phoneError ||
    !!lockerError ||
    !!streetError ||
    !!houseNoError ||
    !!flatNoError ||
    !!cityError ||
    !!zipCodeError
  );
};

export default useHasNewRecipientOrderErrors;
